import styled, { css } from "styled-components";
import { device } from "../styles/mediaqueries";
import { brandColor, dustyGrey, textAlt } from "../styles/variables";

export const baseStyle = css`
  color: ${brandColor};
  margin-top: ${({ top }) => (top ? "37px" : "0")};
`;

export const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MainContainer = styled.div`
  width: 450px;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${device.mobileL} {
    width: 335px;
  }
`;

export const MainForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
`;

// With wrapper, target the svg
export const IconWrapper = styled.div`
  svg {
    width: 148px;
    height: 155px;

    ${device.mobileL} {
      width: 120px;
      height: 124px;
    }
  }
`;

export const Heading1 = styled.h1`
  ${baseStyle}
  font-size: 32px;
  text-transform: uppercase;
`;

export const Heading2 = styled.h2`
  ${baseStyle}
  font-weight:400;
  font-size: 26px;
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 0;

  ${device.mobileL} {
    font-size: 20px;
  }
`;

export const Heading3 = styled.h3`
  ${baseStyle}
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 20px;
  text-align: center;

  ${device.mobileL} {
    font-size: 18px;
  }
`;

export const Heading4 = styled.h4`
  ${baseStyle}
  font-size: 14px;
`;

export const Paragraph = styled.p`
  font-size: 15px;
  font-weight: 300;
  line-height: 22px;
  text-align: center;
  margin-bottom: 30px;
  margin-top: 0;
  width: ${(props) => (props.width ? props.width : "100%")};

  ${device.mobileL} {
    font-size: 14px;
    width: 270px;
  }
`;

export const Label = styled.label`
  font-weight: 300;
  width: 342px;
  font-size: 12px;
  color: ${dustyGrey};
  line-height: 18px;
  text-align: center;

  u {
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      color: ${brandColor};
    }
  }

  ${device.mobileL} {
    width: 295px;
  }
`;

export const MessageIcon = styled.img.attrs((props) => ({
  src: props.url,
}))`
  width: 150px;
  margin-bottom: 40px;

  ${device.mobileL} {
    width: 120px;
    margin-bottom: 30px;
  }
`;

export const UnsubscribeText = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: ${textAlt};
  line-height: "20px";
  text-align: center;
  width: 50%;
  margin: auto;
  margin-bottom: 200px;

  ${device.tablet} {
    margin-bottom: 120px;
    width: 70%;
  }

  ${device.mobileL} {
    margin-bottom: 100px;
    width: 80%;
  }
`;
